/* src/app/components/deviceinventory/deviceinventory.component.scss */
.bottom-padding {
  padding-bottom: 40px;
}
.bottom-padding-small {
  padding-bottom: 30px;
}
.inventory-tab-span {
  font-size: 25px;
  font-weight: bold;
}
.nav > li {
  margin-left: 0;
}
.nav-link.active,
.nav > li > a:focus,
.nav > li > a:hover {
  background-color: #0071bb;
  color: #fff;
}
.hidden {
  display: none;
}
.e-datepicker {
  pointer-events: none;
}
.e-checkbox-wrapper,
.e-css.e-checkbox-wrapper {
  -webkit-tap-highlight-color: transparent;
  padding-left: 5px;
}
.e-grid .e-rowcell .e-checkbox-wrapper,
.e-grid .e-rowcell .e-css.e-checkbox-wrapper {
  padding-left: 5px;
}
.e-control,
.e-css {
  font-size: 14px !important;
  font-weight: normal;
}
.tooltip-span {
  padding: 3px 5px 3px 20px;
}
.ha-state-toolbar-action {
  display: inline-block;
}
.ha-state-toolbar-action button:disabled {
  pointer-events: none;
}
#dialog .card-footer {
  text-align: center;
  background-color: #ffffff;
  border-top: none;
  padding-bottom: 20px;
}
#dialog .card-footer button {
  margin: 10px;
}
.p-no-margin {
  margin: 0;
}
.e-toolbar-items {
  border-left: solid 1px #ccc !important;
}
.checkbox-header-manage-di {
  border-right: solid 0px #fff !important;
}
.checkbox-header-submission-history {
  border-right: solid 1px #cccccc !important;
}
#dialog_dialog-content {
  padding: 0;
}
.card-primary {
  border: none;
}
.card ul {
  list-style-type: disc;
}
.card ul li {
  border: none !important;
  cursor: default !important;
}
.pb {
  width: 100px;
  height: 30px;
}
.ha-state-dialog .card-header h4 {
  font-size: 18px;
  margin: 0;
}
.ha-state-history-dialog {
  margin-bottom: 0;
  border: solid 1px #8c8c8c;
}
.ha-state-history-dialog .card-body {
  padding: 0 0 10px 0;
}
.ha-state-history-dialog .card-footer {
  text-align: center;
  background-color: #ffffff;
  border-top: none;
  padding-bottom: 20px;
}
.ha-state-history-dialog .card-footer button {
  margin: 10px;
}
.ha-state-history-dialog .card-body .table-inner td {
  padding-left: 15px;
}
.ha-state-alert,
.ha-state-cascade-warning {
  border: 1px solid #d9b64f;
  background-color: #fff7db;
  padding: 10px;
  margin-bottom: 12px;
}
.ha-state-cascade-warning {
  border-color: #0071bb;
  background-color: #e7f4fb;
}
/*# sourceMappingURL=deviceinventory.component.css.map */
